import { render, staticRenderFns } from "./LabelList.vue?vue&type=template&id=e35904fe&scoped=true&"
import script from "./LabelList.vue?vue&type=script&lang=js&"
export * from "./LabelList.vue?vue&type=script&lang=js&"
import style0 from "./LabelList.vue?vue&type=style&index=0&id=e35904fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35904fe",
  null
  
)

export default component.exports